import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
 
//note: sharing link with tl get value will automatically open registration form for the event with the id contained in the tl value eg https://events.example.com?tl=123
  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dashboard/:role_id',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/event/EventsDashboard.vue')
  },
  {
    path: '/eventpass/:event_title/:userid',
    name: 'Event Pass',
    component: () => import(/* webpackChunkName: "about" */ '../views/event/EventPass.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
